/**
 * Created by Administrator on 2017/7/2.
 */
export const SHOWCAROUSEL = 'ShowCarousel';
export const LOADCAROUSEL = 'LoadCarousel';


// WEBPACK FOOTER //
// ./src/Component/MyCarousel/actionTypes.js